<template>
    <div class="d-flex flex-wrap flex-stack my-5">
        <h2 class="fs-2 fw-bold my-2">
            {{ $t('pages.statistic.general.title') }}
        </h2>
        <button :data-kt-indicator="refreshLoading ? 'on' : null" class="btn btn-primary er fs-6 px-8 py-4" type="button" @click="refreshStatistic" :disabled="refreshLoading">
            <span v-if="!refreshLoading" class="indicator-label">{{ $t('pages.statistic.general.refresh') }}</span>
            <span v-if="refreshLoading" class="indicator-progress">
                {{ $t("messages.wait") }}
                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
        </button>
    </div>
    <StatisticGeneral ref="generalStatistic"></StatisticGeneral>
</template>

<script>
import StatisticGeneral from "@/components/statistic/general";
export default {
    name: "index",
    components: {
        StatisticGeneral
    },
    data(){
        return {
            refreshLoading: false
        }
    },
    mounted(){
        this.setCurrentPageBreadcrumbs(this.$t('pages.statistic.general.title'), [this.$t('menu.statistic.title')]);
    },
    methods: {
        refreshStatistic(){
            this.refreshLoading = true;

            this.axios.post(this.endpoints['statistic_general']).then(response => {
                this.onResponse(response.data, () => {
                    this.$refs.generalStatistic.loadStatistics();
                }, undefined, false);
            }).catch(error => {
                this.onResponseFailure(error.response.data);
            }).finally(() => {
                this.refreshLoading = false;
            });
        }
    }
}
</script>

<style scoped>

</style>